import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getAdminNoticeList } from '../../lib/api/notice-support-api';
import './NoticeManagement.css';

function NoticeManagement() {
  const { token } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getAdminNoticeList(token);
        setRows(response?.data || []);
      } catch (err) {
        setError(err.message || '공지사항 관리 목록 조회에 실패했습니다.');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [token]);

  return (
    <div className="notice-management">
      {loading && <div className="admin-table-status">불러오는 중입니다...</div>}
      {!!error && <div className="admin-table-status error">{error}</div>}

      <table className="admin-basic-table">
        <thead>
          <tr>
            <th style={{ width: '70px' }}>번호</th>
            <th>제목</th>
            <th style={{ width: '110px' }}>작성일</th>
            <th style={{ width: '84px' }}>조회수</th>
            <th style={{ width: '100px' }}>팝업여부</th>
            <th style={{ width: '110px' }}>팝업가로</th>
            <th style={{ width: '110px' }}>팝업세로</th>
            <th style={{ width: '240px' }}>게시기간</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((notice, index) => (
            <tr key={notice.id}>
              <td>{rows.length - index}</td>
              <td>{notice.title}</td>
              <td>{notice.date}</td>
              <td>{notice.views}</td>
              <td>{notice.popup?.enabled ? 'Y' : 'N'}</td>
              <td>{notice.popup?.width || '-'}{notice.popup?.width ? 'px' : ''}</td>
              <td>{notice.popup?.height || '-'}{notice.popup?.height ? 'px' : ''}</td>
              <td>
                {notice.popup?.startAt ? String(notice.popup.startAt).slice(0, 10) : '-'}
                {' ~ '}
                {notice.popup?.endAt ? String(notice.popup.endAt).slice(0, 10) : '-'}
              </td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan={8} className="admin-empty-row">데이터가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default NoticeManagement;
